module.exports = __webpack_public_path__ + "static/media/NoyhGeometric-Bold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NoyhGeometric-Bold.otf
// module id = 890
// module chunks = 0